// BrentHaus menu data — aggiornato da MENU FOOD Settembre.pdf + MENU DRINK Settembre.pdf
export const categories = [
  {
    id: "cicchetti",
    label: "Cicchetti",
    items: [
      { name: "1/2 uovo ripieno e acciuga del Cantabrico", desc: "(3)(4)(6)(10)", price: "1,5" },
      { name: "Bruschettina con crema di zucca e pastin", desc: "(1)(6)(10)(12)", price: "4" },
      { name: "Mini Kekostine", desc: "Mini pane buns con pulled di costine e coleslaw · (1)(6)(7)(10)(12)", price: "6" },
      { name: "Mini Kekostine vegetale", desc: "Mini pane buns con pulled di sbrise e coleslaw · (1)(6)(7)(10)(12)", price: "6" },
      { name: "Polpetta di zucca", desc: "Cuore di mozzarella e maionese ai funghi · (1)(6)(7)(10)", price: "3,5" },
      { name: "3 polpettine di manzo", desc: "Con salsa Brenthaus · (1)(3)(4)(6)(7)(10)(12)", price: "4,5" },
      { name: "Straccetti di pollo fritto", desc: "Con salsa agropiccante · (1)(3)(4)(6)(10)(12)", price: "5" },
      { name: "Tartarina di manzo (90g)", desc: "Con crostini di pane · (1)(3)(4)(6)(10)(12)", price: "9" },
    ],
  },
  {
    id: "affettati-formaggi",
    label: "Affettati & Formaggi",
    groups: [
      {
        title: "Affettati",
        items: [
          { name: "Prosciutto crudo \"D'Osvaldo\"", desc: "Stagionato leggermente affumicato · 100% italiano", price: "8" },
          { name: "Guanciale \"D'Osvaldo\"", desc: "Stagionato leggermente affumicato · 100% italiano", price: "6" },
          { name: "Speck \"Riserva\"", desc: "Dobbiaco · Südtirol", price: "7" },
          { name: "Mortadella con pistacchi", desc: "100% italiano · (8)", price: "6" },
          { name: "Gran tagliere di affettati", desc: "Con giardiniera fatta in casa e focaccia · (12)", price: "20" },
        ],
      },
      {
        title: "Formaggi",
        items: [
          { name: "Pecorino toscano stagionato", desc: "Prodotto in Toscana con latte 100% italiano · (7)", price: "7" },
          { name: "Pecorino stagionato al tartufo", desc: "Prodotto in Toscana con latte 100% italiano · (7)", price: "7,5" },
          { name: "Scorzabionda stagionato di capra", desc: "Prodotto in Toscana con latte 100% italiano · (7)", price: "7" },
          { name: "Erborinato di pecora \"Gorg'Ovino\"", desc: "Prodotto in Toscana con latte 100% italiano · (7)", price: "6,5" },
          { name: "Gran tagliere di formaggi", desc: "Con confetture e focaccia · (7)(10)(12)", price: "20" },
        ],
      },
    ],
  },
  {
    id: "primi",
    label: "Primi",
    items: [
      { name: "Bigoli al ragù d'anatra", desc: "(1)(3)(6)(7)(10)(12)", price: "14" },
      { name: "Fusilloni con crema di zucca", desc: "Nocciole tostate e pecorino erborinato · (1)(3)(6)(7)(8)(10)", price: "12" },
    ],
  },
  {
    id: "secondi",
    label: "Secondi",
    items: [
      { name: "Stinco di maiale", desc: "Con cavolo rosso fermentato · (1)(4)(6)(10)(12)", price: "16" },
      { name: "Gulash di manzo", desc: "Con crostoni di pane tostato · (1)(6)(10)(12)", price: "16" },
      { name: "Pollo fritto", desc: "Con patatine e salsa agropiccante · (1)(3)(4)(6)(10)(12)", price: "14" },
      { name: "Tartare di manzo (180g)", desc: "Con crostini di pane · con aggiunta di tartufo +3 · (1)(3)(4)(6)(10)(12)", price: "18" },
    ],
  },
  {
    id: "panini",
    label: "Panini",
    items: [
      { name: "Brenthaus Burger", desc: "Pane buns, hamburger di manzo 200g, guanciale croccante, pecorino al tartufo, cipolla caramellata, salsa Brenthaus · (1)(3)(4)(6)(7)(10)", price: "16" },
      { name: "Fall Burger", desc: "Pane buns, pollo fritto, speck, champignon spadellati, misticanza, maionese · (1)(3)(4)(6)(7)(10)(12)", price: "14" },
      { name: "Hot Dog", desc: "Sfilatino, würstel 150g, formaggio, cipolla caramellata, maionese senapata · (1)(6)(7)(10)(12)", price: "12" },
      { name: "Cheese Burger", desc: "Pane buns, hamburger di manzo 200g, formaggio, misticanza, pomodoro · (1)(6)(7)(10)", price: "13" },
      { name: "Kekostine", desc: "Pane buns artigianale, pulled di costine, coleslaw · (1)(6)(7)(10)(12)", price: "14" },
      { name: "Kekostine vegetale", desc: "Pane buns, pulled di sbrise, coleslaw · (1)(6)(7)(10)(12)", price: "12" },
      { name: "Zucca Burger", desc: "Pane buns, burger di zucca, maionese ai funghi, cipolla caramellata, misticanza · (1)(6)(7)(10)", price: "12" },
      { name: "Con patatine", desc: "Supplemento", price: "+2,5" },
      { name: "Doppio hamburger", desc: "Supplemento", price: "+7" },
    ],
  },
  {
    id: "contorni",
    label: "Contorni & Salse",
    items: [
      { name: "Patate al forno", desc: "", price: "4" },
      { name: "Contorno di stagione", desc: "", price: "4" },
      { name: "Patate fritte", desc: "Prodotto surgelato", price: "4" },
      { name: "Salse", desc: "Maionese, ketchup, salsa rosa, BBQ, senape", price: "0,50" },
    ],
  },
  {
    id: "dolci",
    label: "Dolci",
    message: {
      title: "Dolci del giorno",
      text: "I nostri dolci cambiano ogni giorno: chiedi a noi cosa c'è di fresco oggi.",
    },
  },
  {
    id: "vini-birre",
    label: "Vini & Birre",
    message: {
      title: "Selezione a rotazione",
      text: "La selezione di vini in mescita e birre alla spina cambia spesso: chiedi a noi o guarda la lavagna. Oltre alla mescita, ampia selezione di vini e birre speciali in bottiglia.",
    },
  },
  {
    id: "cocktails",
    label: "Cocktails",
    groups: [
      {
        title: "Aperitivi",
        items: [
          { name: "Spritz Aperol", desc: "Aperol, spumante, seltz", price: "4" },
          { name: "Spritz Campari", desc: "Campari, spumante, seltz", price: "4" },
          { name: "Spritz Cynar", desc: "Cynar, spumante, seltz", price: "4" },
          { name: "Americano", desc: "Bitter, vermut, seltz", price: "5" },
          { name: "Negroni", desc: "Bitter, vermut, gin", price: "7" },
        ],
      },
      {
        title: "Cocktail",
        items: [
          { name: "Boulevardier", desc: "Bitter, vermut, bourbon", price: "9" },
          { name: "Cosmopolitan", desc: "Vodka, Cointreau, lime, cranberry", price: "8" },
          { name: "Daiquiri", desc: "Rum, lime, zucchero", price: "7" },
          { name: "Espresso Martini", desc: "Espresso, vodka, liquore al caffè, zucchero", price: "8" },
          { name: "Long Island", desc: "Gin, rum, vodka, tequila, Cointreau, limone, zucchero, cola", price: "9" },
          { name: "Gin Fizz", desc: "Gin, limone, zucchero, seltz", price: "7" },
          { name: "Moscow Mule", desc: "Vodka, lime, ginger beer", price: "8" },
          { name: "Margarita", desc: "Tequila, Cointreau, lime", price: "7" },
          { name: "Martini Cocktail", desc: "Gin, vermut dry", price: "9" },
          { name: "Old Fashioned", desc: "Bourbon, zucchero, Angostura", price: "9" },
          { name: "Paloma", desc: "Tequila, lime, tonica al pompelmo rosa", price: "8" },
          { name: "White Lady", desc: "Gin, Cointreau, zucchero, limone", price: "7" },
          { name: "Whiskey Sour", desc: "Bourbon, zucchero, limone", price: "8" },
        ],
      },
    ],
  },
  {
    id: "gin-tonic",
    label: "Gin Tonic",
    note: "Gin Tonic o Gin Lemon",
    items: [
      { name: "Verum Gin · London Dry", desc: "Secco e profumato · 40% · Italia", price: "6" },
      { name: "Servaj Gin · Papavero", desc: "Vivace ed erbaceo · 42% · Italia", price: "8" },
      { name: "Gin Fontezoppa · Pepe Dry", desc: "Fresco e agrumato · 40% · Italia", price: "8" },
      { name: "Me Fusion Gin · Pepe Rosa", desc: "Intenso e speziato · 42% · Italia", price: "8" },
      { name: "Dune di Venezia · Gin Agricolo", desc: "Morbido ed erbaceo · 40% · Italia", price: "8" },
      { name: "Plymouth · Original Strength", desc: "Fresco e morbido · 41,2% · Inghilterra", price: "8" },
      { name: "Spirito di Mamma · Pomodoro e basilico", desc: "Mediterraneo e speziato · 40% · Italia", price: "9" },
      { name: "Pao de Sitges · London Dry", desc: "Vivace e mediterraneo · 41% · Spagna", price: "9" },
      { name: "Nonna Oliva · Olive e foglie di ulivo", desc: "Morbido e minerale · 41% · Italia", price: "10" },
      { name: "Hornby Lighthouse · Navy Strength", desc: "Intenso ed erbaceo · 57,15% · Italia", price: "10" },
      { name: "Brace · BBQ London Dry", desc: "Sapido e speziato · 40% · Italia", price: "12" },
      { name: "Buckingham", desc: "Analcolico", price: "7" },
    ],
  },
  {
    id: "amari-grappe",
    label: "Amari & Grappe",
    groups: [
      {
        title: "Amari e grappe",
        items: [
          { name: "Nardini Bianca", desc: "50%", price: "4" },
          { name: "Nardini Extrafina", desc: "42%", price: "5" },
          { name: "Nardini Riserva 3 anni", desc: "50%", price: "5" },
          { name: "Nardini Riserva 5 anni", desc: "42%", price: "6" },
          { name: "Nardini Acqua di Cedro", desc: "29%", price: "3" },
          { name: "Amaro del Ciclista", desc: "30%", price: "4" },
          { name: "Amaro San Giuseppe", desc: "32%", price: "4" },
          { name: "Kaiserfost", desc: "32%", price: "4" },
          { name: "Gazunt", desc: "25%", price: "4" },
          { name: "Kopke · Porto", desc: "Portogallo · 20%", price: "7" },
          { name: "Amaro 20", desc: "Analcolico", price: "4" },
        ],
      },
      {
        title: "Caffè",
        items: [
          { name: "Caffè", desc: "", price: "1,5" },
          { name: "Caffè corretto", desc: "", price: "2,5" },
        ],
      },
    ],
  },
  {
    id: "bibite",
    label: "Bibite",
    items: [
      { name: "Acqua naturale / frizzante", desc: "Vetro 50cl", price: "2" },
      { name: "Acqua Brillante", desc: "Vetro 20cl", price: "2,5" },
      { name: "Tonica al pompelmo rosa", desc: "Vetro 20cl", price: "4" },
      { name: "Ginger Beer", desc: "Vetro 20cl", price: "4" },
      { name: "Coca-Cola", desc: "Vetro 33cl", price: "4" },
      { name: "Coca-Cola Zero", desc: "Vetro 33cl", price: "4" },
      { name: "OranSoda", desc: "Vetro 20cl", price: "3" },
      { name: "LemonSoda", desc: "Vetro 20cl", price: "3" },
      { name: "Cedrata Tassoni", desc: "Vetro 18cl", price: "3,5" },
      { name: "Tè alla pesca Bio Sibi", desc: "Vetro 35,5cl", price: "4,5" },
      { name: "Tè al limone Bio Sibi", desc: "Vetro 35,5cl", price: "4,5" },
      { name: "Tè nero Bio Sibi", desc: "Vetro 35,5cl", price: "4,5" },
    ],
  },
];

// Allergen legend — Allegato II Reg. UE 1169/2011
export const allergens = [
  { n: 1, label: "Cereali contenenti glutine" },
  { n: 2, label: "Crostacei" },
  { n: 3, label: "Uova" },
  { n: 4, label: "Pesce" },
  { n: 5, label: "Arachidi" },
  { n: 6, label: "Soia" },
  { n: 7, label: "Latte e derivati (incluso lattosio)" },
  { n: 8, label: "Frutta a guscio" },
  { n: 9, label: "Sedano" },
  { n: 10, label: "Senape" },
  { n: 11, label: "Semi di sesamo" },
  { n: 12, label: "Anidride solforosa e solfiti" },
  { n: 13, label: "Lupini" },
  { n: 14, label: "Molluschi" },
];
